import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import { GroupedAssignment } from "../measurementTypes";

export default function AssignedProductRow({ assignment }: { assignment: GroupedAssignment }) {
  return (
    <MDBox
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap="12px"
      sx={{ border: "1px solid #E5E7EB", borderRadius: "8px", p: "10px" }}
    >
      <MDBox>
        <UiTypography uiVariant="body-sm" sx={{ fontWeight: 600 }}>
          {assignment.productName}
        </UiTypography>
        <UiTypography uiVariant="caption" sx={{ color: "#667085" }}>
          Job Size: {assignment.total.toLocaleString()}
        </UiTypography>
      </MDBox>
      <UiTypography
        uiVariant="caption"
        sx={{
          color: assignment.hasScreenshot ? "#0094c6" : "#667085",
          fontWeight: assignment.hasScreenshot ? 700 : 500,
          whiteSpace: "nowrap",
        }}
      >
        {assignment.hasScreenshot ? "Screenshot included" : "Assigned"}
      </UiTypography>
    </MDBox>
  );
}
